// @flow
import React from 'react';
import styles from './Content.module.scss';
import { useAppDarkMode } from '../../../hooks';


type Props = {
  body: string,
  title: string
};

const Content = ({ body, title }: Props) => {
  const { value } = useAppDarkMode(false);
  return (
    <div className={styles['content']}>
      <h1 className={styles[value ? 'content__dark-title' : 'content__light-title']}>{title}</h1>
      <div className={styles[value ? 'content__body-dark' : 'content__body-light']} dangerouslySetInnerHTML={{ __html: body }} />
    </div>
  );
}

export default Content;
